const RESERVED_GAMES_SEGMENTS = [
  'category',
  'providers',
  'live',
  'jogos-do-padrinho',
];

function isGameRoute(path: string) {
  const match = path.match(/^\/games\/([^/]+)\/[^/]+/);

  if (!match || !match[1]) return false;

  return !RESERVED_GAMES_SEGMENTS.includes(match[1]);
}

export default defineNuxtRouteMiddleware((to) => {
  if (!isGameRoute(to.path)) return;

  // Redireciona no servidor antes de enviar qualquer HTML — elimina flash de
  // página em branco no mobile quando o usuário acessa a URL diretamente.
  if (import.meta.server) {
    const headers = useRequestHeaders(['user-agent']);
    const ua = headers['user-agent'] ?? '';

    if (/Mobi|Android|iPhone|iPad|iPod/i.test(ua)) {
      // Bypass: ?direct=true em usuário logado abre o jogo direto, sem preview.
      // Autenticação é inferida pelo cookie jwt_token (mesma fonte do useJwtStore).
      const jwtCookie = useCookie('jwt_token');
      const isLogged = !!jwtCookie.value;

      if (to.query.direct === 'true' && isLogged) return;

      const parts = to.path.split('/').filter(Boolean);
      const slug = `${parts[1]}/${parts[2]}`;

      return navigateTo({ path: '/', query: { previewGame: slug } });
    }
  }
});
